import React, { useEffect, useState } from 'react'
import '../hometabs/HomeTabs.css'
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import useApi from '../../customHook/useApi';
import { useSelector } from 'react-redux';


const SuggestedTabs = () => {
    const { userId } = useSelector((state) => state.user);
    const { data: suggestionData, get: getSuggestion } = useApi('https://codezens.com/luststory/index.php/api');
    const { data: postsData, get: getPosts } = useApi('https://codezens.com/luststory/index.php/api');
    const { postFormData: toggleFollow } = useApi('https://codezens.com/luststory/index.php/api');

    const [followingStatus, setFollowingStatus] = useState({});

    useEffect(() => {
        // Fetch the Suggested users
        getSuggestion(`/get_suggestions?auth_id=${userId}`);
        // Fetch the posts
        getPosts(`/get_posts?auth_id=${userId}&status=Suggestion`);
    }, [getSuggestion, getPosts, userId]);

    const onFollowClick = async (userId) => {
        try {
            const response = await toggleFollow(`/toggle_follow_status`, { auth_id: 9, user_id: userId });

            if (response && response.status === 1) {
                // Update the follow status locally
                setFollowingStatus((prevStatus) => ({
                    ...prevStatus,
                    [userId]: !prevStatus[userId]  // Toggle follow status
                }));
            } else {
                toast.error('Failed to toggle follow status');
            }
        } catch (error) {
            toast.error(error?.message || error);
        }
    };

    return (

        <div className='tabs-homepage suggested-sec'>
            <div className='tabs-head'>
                <ul className='d-flex flex-wrap justify-content-center'>
                    {suggestionData?.result?.map((user) => (
                        <li key={user.user_id}>
                            <span className="tabs-img"><img src={user.user_image} alt='user-img' /></span>
                            <span className="tabs-text">{user.name}</span>
                        </li>
                    ))}
                </ul>
            </div>
            <div className='tabs-bottom-box'>
                {postsData?.result?.map((post) => (
                    <div className="tabs-box" key={post.post_id}>
                        <div className="tabs-content d-flex flex-wrap align-items-center">
                            <div className="left-img"><img src={post.user_image} alt='user-img' /></div>
                            <div className="right-box">
                                <h5>
                                    {post.username} <span>{post.created_at}</span>
                                </h5>
                                <p>{post.title}</p>
                            </div>
                        </div>
                        <div className='btn-right-follow position-relative'>
                            <button onClick={() => onFollowClick(post.user_id)} className='btn btn-border'>{followingStatus[post.user_id] ? 'Following' : 'Follow'}</button>
                        </div>
                        {post.image?.length > 0 && (
                            <div className="two-img-box">
                                <ul className="d-flex flex-wrap">
                                    {post.image.map((image, index) => (
                                        <li key={index} className="img-box">
                                            <img src={image} alt="post-img" />
                                        </li>
                                    ))}
                                    {post.video?.map((video, index) => (
                                        <li key={index} className="video-box">
                                            <video width="100%" controls>
                                                <source src={video} type="video/mp4" />
                                                Your browser does not support the video tag.
                                            </video>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div>
                ))}
                <div className='tabs-box position-relative'>
                    <div className='tabs-suggested-box d-flex flex-wrap '>
                        <div className='tabs-content d-flex flex-wrap align-items-center'>
                            <div className='left-img'></div>
                            <div className='right-box'>
                                <h5>chloelovesyou <span>9h</span></h5>
                                <p>Send me moneyyyyyyyy! </p>
                            </div>
                        </div>
                        <div className='btn-right-follow position-relative'>
                            <Link rel='stylesheet' to="/" className='btn btn-border'>Follow</Link>
                        </div>
                    </div>
                    <div className='two-img-box'>
                        <ul className='d-flex flex-wrap '>
                            <li className='img-box'></li>
                            <li className='img-box'></li>
                        </ul>
                    </div>

                    <span className='fire-img'>
                        <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 11.2857C16 16.4286 12.25 19 8.50001 19C4.74999 19 1 16.4286 1 11.2857C1 7.42858 2.875 5.50001 4.12501 4.85715C4.12501 6.78572 4.75001 8.07144 5.37501 8.7143C9.12502 7.42858 9.75002 3.57143 9.75002 1C12.25 2.92857 16 6.14286 16 11.2857Z" stroke="#FD59D9" stroke-linecap="round" stroke-linejoin="round" /></svg>
                    </span>
                </div>
                <div className='tabs-box'>
                    <div className='tabs-content d-flex flex-wrap align-items-center'>
                        <div className='left-img'></div>
                        <div className='right-box'>
                            <h5>chloelovesyou <span>9h</span></h5>
                            <p>Send me moneyyyyyyyy! </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SuggestedTabs
